import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { EmergencyNotificationConfigurationFormController } from '../EmergencyNotificationConfigurationForm.types';

import { EmergencyNotificationSmsConfigurationContactPersonsInteractiveTable } from './contactPersons/EmergencyNotificationSmsConfigurationContactPersonsInteractiveTable';

type EmergencyNotificationSmsConfigurationContactPersonsFieldProps = Pick<
   EmergencyNotificationConfigurationFormController,
   'register'
> & {
   readonly emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
};

export const EmergencyNotificationSmsConfigurationContactPersonsField = (
   props: EmergencyNotificationSmsConfigurationContactPersonsFieldProps
): JSX.Element => {
   return (
      <EmergencyNotificationSmsConfigurationContactPersonsInteractiveTable
         register={props.register}
         emergencyNotificationConfiguration={props.emergencyNotificationConfiguration}
      />
   );
};
